import React, { useState, useEffect } from 'react';
import { Box, Text, Button } from '@chakra-ui/react';
import { Colors } from '../../utils/constants';

interface IProps {
  isCountdownActive: boolean;
  setIsCountdownActive: React.Dispatch<React.SetStateAction<boolean>>;
  countdown?: number;
  color?: string;
}
const Countdown = ({ isCountdownActive, setIsCountdownActive, countdown = 120, color }: IProps) => {
  const [time, setTime] = useState(countdown); // 2 minutes in seconds

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (isCountdownActive) {
      setTime(countdown); // Reset to countdown minutes when countdown is activated
      timer = setInterval(() => {
        setTime((prevTime) => {
          if (prevTime > 0) {
            return prevTime - 1;
          } else {
            setIsCountdownActive(false); // Stop countdown when it reaches 0
            clearInterval(timer);
            return 0;
          }
        });
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [isCountdownActive, setIsCountdownActive]);

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  };

  return (
    <Box>
      <Text
        fontSize='12px'
        fontFamily={'Poppins'}
        lineHeight={'150%'}
        fontWeight={'inherit'}
        color={color ?? Colors.black}
      >
        {formatTime(time)}
      </Text>
    </Box>
  );
};

export default Countdown;
